"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.minimumOfTwoDates = exports.maximumOfTwoDates = exports.getDatesBetween = exports.getWeekdayName = exports.getWeekday = exports.isSameYear = exports.isSameDate = exports.differenceInDurationUnit = exports.toISOString = exports.isOnWeekend = exports.endOfDay = exports.startOfDay = exports.formatMoment = exports.differenceInDays = exports.addDays = exports.subtractAmountOfDuration = exports.subtractDays = exports.isBetween = exports.isAfter = exports.isSameOrBefore = exports.isBefore = exports.isToday = exports.getYear = exports.getToday = exports.getMoment = exports.compareDates = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _moment = _interopRequireDefault(require("moment"));

var WEEK_DAY_TO_NAME = {
  0: 'SUNDAY',
  1: 'MONDAY',
  2: 'TUESDAY',
  3: 'WEDNESDAY',
  4: 'THURSDAY',
  5: 'FRIDAY',
  6: 'SATURDAY'
};
/**
 * Compares two dates together. Can be used to sort an array of dates e.g history of goals,
 * registrations etc.
 * NOTE: I'm putting this one as an exportable unit because I need this method in my selectors
 * (illnesses and registrations)
 * @param {string} timeStampA One of the two date strings to be compared.
 * @param {string} timeStampB The other date string to be compared.
 */

var compareDates = function compareDates(timeStampA, timeStampB) {
  return _moment["default"].utc(timeStampA).diff(_moment["default"].utc(timeStampB));
};
/**
 * Takes in a date and returns a moment object
 */


exports.compareDates = compareDates;

var getMoment = function getMoment(date) {
  return (0, _moment["default"])(date);
};
/**
 * Returns the moment object for today
 */


exports.getMoment = getMoment;

var getToday = function getToday() {
  return (0, _moment["default"])();
};
/**
 * Returns the current year
 */


exports.getToday = getToday;

var getYear = function getYear() {
  return (0, _moment["default"])().year();
};
/**
 * Determines if the provided date is today
 */


exports.getYear = getYear;

var isToday = function isToday(date) {
  return (0, _moment["default"])(date).isSame((0, _moment["default"])(), 'day');
};
/**
 * year month week day hour minute second
 */


exports.isToday = isToday;

var isBefore = function isBefore(date, referenceDate) {
  var granularity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _moment["default"])(date).isBefore(referenceDate, granularity);
};
/**
 * year month week day hour minute second
 */


exports.isBefore = isBefore;

var isSameOrBefore = function isSameOrBefore(date, referenceDate) {
  var granularity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _moment["default"])(date).isSameOrBefore(referenceDate, granularity);
};
/**
 * year month week day hour minute second
 */


exports.isSameOrBefore = isSameOrBefore;

var isAfter = function isAfter(date, referenceDate) {
  var granularity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _moment["default"])(date).isAfter(referenceDate, granularity);
};
/**
 * Determines whether the provided date is between the two other provided dates.
 */


exports.isAfter = isAfter;

var isBetween = function isBetween(date, from, to) {
  var inclusion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '[]';
  return (0, _moment["default"])(date).isBetween(from, to, null, inclusion);
};
/**
 * Subtracts a number of days from the provided date
 */


exports.isBetween = isBetween;

var subtractDays = function subtractDays(date, days) {
  return (0, _moment["default"])(date).subtract(days, 'days');
};
/**
 * Subtracts an amount of some duration (e.g week, month, year) from the given date.
 */


exports.subtractDays = subtractDays;

var subtractAmountOfDuration = function subtractAmountOfDuration(date, amount, duration) {
  return (0, _moment["default"])(date).subtract(amount, duration);
};
/**
 * Adds a number of days to the provided date
 */


exports.subtractAmountOfDuration = subtractAmountOfDuration;

var addDays = function addDays(date, days) {
  return (0, _moment["default"])(date).add(days, 'days');
};
/**
 * Calculates the difference in days between two dates
 */


exports.addDays = addDays;

var differenceInDays = function differenceInDays(date, referenceDate) {
  return (0, _moment["default"])(date).diff(referenceDate, 'days');
};
/**
 * Formats the provided date based on the provided format. Defaults to ISO.
 */


exports.differenceInDays = differenceInDays;

var formatMoment = function formatMoment(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
  return (0, _moment["default"])(date).format(format);
};
/**
 * Moves the time of the provided date to the start of the day
 */


exports.formatMoment = formatMoment;

var startOfDay = function startOfDay(date) {
  return (0, _moment["default"])(date).startOf('day');
};
/**
 * Moves the time of the provided date to the end of the day
 */


exports.startOfDay = startOfDay;

var endOfDay = function endOfDay(date) {
  return (0, _moment["default"])(date).endOf('day');
};
/**
 * Determines if a date is on a weekend
 */


exports.endOfDay = endOfDay;

var isOnWeekend = function isOnWeekend(date) {
  var weekDay = (0, _moment["default"])(date).isoWeekday(); // Saturday = 6
  // Sunday = 7

  return weekDay === 6 || weekDay === 7;
};
/**
 * Returns the ISO string of the given moment
 */


exports.isOnWeekend = isOnWeekend;

var toISOString = function toISOString(date) {
  return (0, _moment["default"])(date).toISOString();
};

exports.toISOString = toISOString;

var differenceInDurationUnit = function differenceInDurationUnit(from, to, durationUnit) {
  return (0, _moment["default"])(from).diff(to, durationUnit);
};
/**
 * Checks whether two dates are the same day
 */


exports.differenceInDurationUnit = differenceInDurationUnit;

var isSameDate = function isSameDate(date, date2) {
  return (0, _moment["default"])(date).isSame(date2, 'day');
};
/**
 * Checks whether two dates are on the same year
 */


exports.isSameDate = isSameDate;

var isSameYear = function isSameYear(date, date2) {
  return (0, _moment["default"])(date).isSame(date2, 'year');
};
/**
 * Gets the weekday number of the moment
 */


exports.isSameYear = isSameYear;

var getWeekday = function getWeekday(date) {
  return (0, _moment["default"])(date).weekday();
};
/**
 * Takes in a date and returns the uppercase name. F.x. SUNDAY
 * @param {Moment like} date
 */


exports.getWeekday = getWeekday;

var getWeekdayName = function getWeekdayName(date) {
  return WEEK_DAY_TO_NAME[(0, _moment["default"])(date).day()];
};
/**
 * Takes in two dates and returns an array of dates that are between them
 */


exports.getWeekdayName = getWeekdayName;

var getDatesBetween = function getDatesBetween(from, to) {
  var start = from;
  var end = to;
  var datesBetween = [];

  while (isSameOrBefore(start, end, 'days')) {
    datesBetween = [].concat((0, _toConsumableArray2["default"])(datesBetween), [formatMoment(start)]); // We increment the walker to the next day

    start = addDays(start, 1);
  }

  return datesBetween;
};
/*
 * Returns the maximum of the two given dates.
 */


exports.getDatesBetween = getDatesBetween;

var maximumOfTwoDates = function maximumOfTwoDates(dateA, dateB) {
  return _moment["default"].max((0, _moment["default"])(dateA), (0, _moment["default"])(dateB));
};
/**
 * Returns the minimum of the two given dates.
 */


exports.maximumOfTwoDates = maximumOfTwoDates;

var minimumOfTwoDates = function minimumOfTwoDates(dateA, dateB) {
  return _moment["default"].min((0, _moment["default"])(dateA), (0, _moment["default"])(dateB));
};

exports.minimumOfTwoDates = minimumOfTwoDates;